














































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import course, { CourseListParams } from "@/getinfo-api/course";
import webinars, { WebinarsListParams } from "@/getinfo-api/webinars";
import video, { VideoListParams } from "@/getinfo-api/video";
import { Course as ICourse } from "@/api/models/course";
import { Webinar as IWebinar } from "@/api/models/webinar";
import { Video as IVideo } from "@/api/models/video";
import { CoursesList as ICoursesList } from "@/api/models/courses-list";
import { CourseUnionList } from "@/api/models/course-union-list";
import { WebinarList as IWebinarList } from "@/api/models/webinar-list";
import { VideoList as IVideoList } from "@/api/models/video-list";
import { getCurrentUserId, isRoot } from "@/plugins/roles";

@Component
export default class MultiplyEntity extends Vue {
  /**
   * @String
   * Available type: course, webinar, video
   * */
  @Prop() type!: string;
  @Prop() companyId!: string;
  @Prop() existSelectedEntity?: Array<string>;
  @Prop() ownerId?: string;
  entityList: Array<ICourse | IWebinar | IVideo> = [];
  selectedEntity: Array<ICourse | IWebinar | IVideo> = [];
  offset: number = 0;
  limit: number = 30;
  entityCount: number = 0;
  showSpinner: boolean = false;
  globalSpinner: boolean = false;

  get userId() {
    return getCurrentUserId();
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  getCourse(offset: number = 0) {
    this.globalSpinner = true;
    const params: CourseListParams = {
      companyIds: [this.companyId],
      ownerIds: this.root || this.companyOwner ? undefined : [this.userId],
      offset: offset,
      limit: this.limit
    };

    course(params)
      .then((res: { data: CourseUnionList }) => {
        this.entityCount = res.data.count;
        res.data.courses?.forEach((el: any) => {
          this.entityList.push(el);
        });
        this.getExistSelectedEntity();
      })
      .finally(() => {
        this.showSpinner = false;
        this.globalSpinner = false;
      });
  }

  getWebinars(offset: number = 0) {
    this.globalSpinner = true;
    const params: WebinarsListParams = {
      companyId: this.companyId,
      ownerId: this.root || this.companyOwner ? undefined : this.userId,
      offset: offset,
      limit: this.limit,
      status: "coming" // только вебинары, которые еще начались
    };

    webinars(params)
      .then((res: { data: IWebinarList }) => {
        this.entityCount = res.data.count;
        res.data.webinars?.forEach(el => {
          this.entityList.push(el);
        });
        this.getExistSelectedEntity();
      })
      .finally(() => {
        this.globalSpinner = false;
        this.showSpinner = false;
      });
  }

  getRecords(offset: number = 0) {
    this.globalSpinner = true;
    const params: VideoListParams = {
      companyId: this.companyId,
      ownerId: this.root || this.companyOwner ? undefined : this.userId,
      offset: offset,
      limit: this.limit
    };

    video(params)
      .then((res: { data: IVideoList }) => {
        this.entityCount = res.data.count;
        res.data.videos?.forEach(el => {
          this.entityList.push(el);
        });
        this.getExistSelectedEntity();
      })
      .finally(() => {
        this.showSpinner = false;
        this.globalSpinner = false;
      });
  }

  showMore() {
    this.offset += this.limit;
    this.typeHandler(this.offset);
  }

  typeHandler(offset: number = 0) {
    this.showSpinner = true;
    if (this.type === "course") this.getCourse(offset);
    if (this.type === "webinar") this.getWebinars(offset);
    if (this.type === "video") this.getRecords(offset);
  }

  selectAll() {
    if (this.selectedEntity.length < this.entityCount) {
      this.selectedEntity = [];
      this.entityList.forEach(el => {
        this.selectedEntity.push(el);
      });
    } else {
      this.selectedEntity = [];
    }
  }

  @Watch("selectedEntity")
  emitSelectEntity() {
    this.$emit("change", this.selectedEntity);
  }

  @Watch("ownerId")
  updByOwner() {
    this.updateEntity();
  }

  @Watch("companyId")
  updByCompany() {
    this.updateEntity();
  }

  updateEntity() {
    this.selectedEntity = [];
    this.entityList = [];
    this.offset = 0;
    this.entityCount = 0;
    this.typeHandler();
  }

  created() {
    this.typeHandler();
  }

  getExistSelectedEntity() {
    if (this.existSelectedEntity) {
      this.existSelectedEntity.forEach(el => {
        this.entityList.forEach(entityEl => {
          if (el === entityEl?.id) {
            this.selectedEntity.push(entityEl);
          }
        });
      });
    }
  }

  checkCheckbox(el: any) {
    return this.existSelectedEntity?.includes(el.id);
  }

  mounted() {}
}
